export default __webpack_public_path__ + "static/media/2077.446afd41.png";